import PresencasResponse from 'models/PresencasResponse';
import { createContext } from 'react';
import { IAssembleiasAssessorEvent, IAssembleiasAssessorReducer } from 'store/modules/AssembleiasAssessorReducer';
import { ThunkDownloadDocumentReturn } from 'store/modules/AssembleiasAssociadoActions';

export type AssembleiaAssessorActionsDownloadDocument = (
  idDocumento: number,
  nome: string
) => ThunkDownloadDocumentReturn;

interface AssembleiaAssociadoContext {
  currentEvent: IAssembleiasAssessorReducer | null;
  assembleiaAssessorActionsDownloadDocument: AssembleiaAssessorActionsDownloadDocument;

  evento: IAssembleiasAssessorEvent | null;
  loadingEvento: boolean;
  loadingPautas: boolean;
  alterarSituacao: Function;
  convocarEvento: Function;
  convocando: boolean;
  bloquearEvento: Function;
  bloqueando: boolean;
  presencas: PresencasResponse | null;
  atualizarPresencas: Function;
  atualizandoPresencas: boolean;
}

export default createContext<AssembleiaAssociadoContext>({
  currentEvent: null,
  assembleiaAssessorActionsDownloadDocument: () => () => Promise.resolve(),
  
  evento: null,
  loadingEvento: true,
  loadingPautas: false,
  alterarSituacao: () => {},
  convocarEvento: () => {},
  convocando: false,
  bloquearEvento: () => {},
  bloqueando: false,
  presencas: null,
  atualizarPresencas: () => {},
  atualizandoPresencas: false,
});
